(function () {
  'use strict';

  const STORAGE_KEY = 'gs_user_zone';
  const ZIP_KEY = 'gs_user_zip';
  const STATE_KEY = 'gs_user_state';
  const MODAL_ID = 'gs-zip-modal';

  function getDisabledText() {
    return document.documentElement.lang === 'ru' ? 'Не доставляется в ваш штат' : "Doesn't ship to your state";
  }

  const STATE_ZONES = {
    'NJ': 'zone-1', 'CT': 'zone-1', 'DE': 'zone-1', 'RI': 'zone-1', 'MA': 'zone-1', 'NY': 'zone-1',
    'MD': 'zone-2', 'PA': 'zone-2', 'NH': 'zone-2', 'VT': 'zone-2',
    'VA': 'zone-3', 'WV': 'zone-3', 'ME': 'zone-3', 'NC': 'zone-3', 'OH': 'zone-3',
    'SC': 'zone-4', 'MI': 'zone-4', 'KY': 'zone-4', 'IN': 'zone-4',
    'TN': 'zone-5', 'GA': 'zone-5', 'IL': 'zone-5', 'WI': 'zone-5', 'AL': 'zone-5',
    'FL': 'zone-6', 'MO': 'zone-6', 'IA': 'zone-6', 'MS': 'zone-6', 'AR': 'zone-6',
    'MN': 'zone-7', 'LA': 'zone-7', 'KS': 'zone-7', 'OK': 'zone-7', 'NE': 'zone-7', 'SD': 'zone-7',
    'ND': 'zone-8', 'TX': 'zone-8', 'CO': 'zone-8', 'WY': 'zone-8', 'NM': 'zone-8', 'MT': 'zone-8',
    'UT': 'zone-9', 'ID': 'zone-9', 'AZ': 'zone-9', 'NV': 'zone-9',
    'WA': 'zone-10', 'OR': 'zone-10', 'CA': 'zone-10', 'AK': 'zone-10', 'HI': 'zone-10',
    'DC': 'zone-2', 'PR': 'zone-10',
  };

  async function getStateFromZip(zip) {
    try {
      const res = await fetch('https://api.zippopotam.us/us/' + zip);
      if (!res.ok) return null;
      const data = await res.json();
      return data.places[0]['state abbreviation'];
    } catch {
      return null;
    }
  }

  function getZoneNumber(zoneStr) {
    if (!zoneStr) return null;
    const match = String(zoneStr).match(/(\d+)/);
    return match ? parseInt(match[1], 10) : null;
  }

  function isAvailableInZone(productZonesAttr, userZone) {
    const userNum = getZoneNumber(userZone);
    if (userNum === null) return true;

    const zoneNums = productZonesAttr
      .split(',')
      .map(getZoneNumber)
      .filter(n => n !== null);

    if (zoneNums.length === 0) return true;

    const maxZone = Math.max(...zoneNums);
    return userNum <= maxZone;
  }

  function getNoticeHTML() {
    const text = getDisabledText();
    return '<span class="gs-zone-notice">' +
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M12 9v4M12 17h.01M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" ' +
      'stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '<span>' + text + '</span>' +
      '</span>';
  }

  function insertNotice(afterEl) {
    if (!afterEl || afterEl.parentNode.querySelector(':scope > .gs-zone-notice')) return;
    const wrapper = document.createElement('div');
    wrapper.innerHTML = getNoticeHTML();
    afterEl.insertAdjacentElement('afterend', wrapper.firstChild);
  }

  function removeNotice(scopeEl) {
    if (!scopeEl) return;
    const notice = scopeEl.parentNode
      ? scopeEl.parentNode.querySelector(':scope > .gs-zone-notice')
      : null;
    if (notice) notice.remove();
  }

  function disableCardButtons(card) {
    const disabledText = getDisabledText();
    card.querySelectorAll(
      '.add-to-cart__submit, .quick-add__submit, .qv_cart_btn'
    ).forEach(btn => {
      if (btn.dataset.gsOriginalText === undefined) {
        btn.dataset.gsOriginalText = btn.textContent.trim();
        btn.dataset.gsOriginalDisabled = btn.disabled ? 'true' : 'false';
      }
      btn.disabled = true;
      btn.classList.add('gs-zone-disabled');
      const span = btn.querySelector('span:not(.sold-out-message):not(.svg-wrapper)');
      if (span) span.textContent = disabledText;
      else btn.textContent = disabledText;

      const container = btn.closest('product-form, quick-add-bulk, .c_same_btn, .custom_qv_btn') || btn.parentElement;
      insertNotice(container);
    });
  }

  function enableCardButtons(card) {
    card.querySelectorAll(
      '.add-to-cart__submit, .quick-add__submit, .qv_cart_btn'
    ).forEach(btn => {
      if (btn.dataset.gsOriginalDisabled === 'false') {
        btn.disabled = false;
      }
      btn.classList.remove('gs-zone-disabled');
      if (btn.dataset.gsOriginalText) {
        const span = btn.querySelector('span:not(.sold-out-message):not(.svg-wrapper)');
        if (span) span.textContent = btn.dataset.gsOriginalText;
      }
      const container = btn.closest('product-form, quick-add-bulk, .c_same_btn, .custom_qv_btn') || btn.parentElement;
      removeNotice(container);
    });
  }

  function applyZoneRules(userZone) {
    if (!userZone) return;

    document.querySelectorAll('product-info[data-zones]').forEach(card => {
      const available = isAvailableInZone(card.getAttribute('data-zones'), userZone);
      if (!available) {
        disableCardButtons(card);
      } else {
        enableCardButtons(card);
      }
    });

    applyZoneRulesProductPage(userZone);
    updateTrigger(userZone);
  }

  function applyZoneRulesProductPage(userZone) {
    const pageZonesEl = document.getElementById('gs-product-zones');
    if (!pageZonesEl) return;

    const available = isAvailableInZone(pageZonesEl.getAttribute('data-zones'), userZone);
    const disabledText = getDisabledText();

    const buttons = document.querySelectorAll(
      '.product-form__submit, [data-type="add-to-cart-form"] [type="submit"]'
    );

    buttons.forEach(btn => {
      const container = btn.closest('product-form, .product-form') || btn.parentElement;
      if (!available) {
        btn.disabled = true;
        btn.classList.add('gs-zone-disabled');
        const span = btn.querySelector('span');
        if (span) span.textContent = disabledText;
        else btn.textContent = disabledText;
        insertNotice(container);
      } else {
        btn.classList.remove('gs-zone-disabled');
        removeNotice(container);
      }
    });
  }

function updateTrigger(zone) {
    const label = document.getElementById('gs-zip-trigger-label');
    const sub = document.getElementById('gs-zip-trigger-sub');
    if (!label) return;

    const zip = localStorage.getItem(ZIP_KEY) || '';
    const state = localStorage.getItem(STATE_KEY) || '';
    const lang = document.documentElement.lang;
    const isRu = lang === 'ru';
    const isUa = lang === 'uk' || lang === 'ua';

    if (zip) {
      label.textContent = zip + (state ? ' · ' + state : '');
      
      if (isRu) {
        sub.textContent = 'Изменить ZIP-код';
      } else if (isUa) {
        sub.textContent = 'Змінити ZIP-код';
      } else {
        sub.textContent = 'Change ZIP code';
      }
    } else {
      if (isRu) {
        label.textContent = 'Введите ZIP-код';
        sub.textContent = 'Узнайте, что доставляется к вам';
      } else if (isUa) {
        label.textContent = 'Введіть ZIP-код';
        sub.textContent = 'Дізнайтеся, що доставляється до вас';
      } else {
        label.textContent = 'Enter ZIP code';
        sub.textContent = 'See what ships to you';
      }
    }
}

  function resetZone() {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(ZIP_KEY);
    localStorage.removeItem(STATE_KEY);
    document.querySelectorAll('.gs-zone-disabled').forEach(btn => {
      btn.disabled = false;
      btn.classList.remove('gs-zone-disabled');
    });
    showModal(true);
  }

  function showModal(allowSkip) {
    if (document.getElementById(MODAL_ID)) return;

    const isRu = document.documentElement.lang === 'ru';

    const el = document.createElement('div');
    el.id = MODAL_ID;
    el.innerHTML = [
      '<div class="gs-overlay" role="dialog" aria-modal="true" aria-labelledby="gs-modal-title">',
      '<div class="gs-box">',
      '<div class="gs-icon">', PIN_SVG, '</div>',
      '<h2 id="gs-modal-title">', isRu ? 'Введите ваш ZIP-код' : 'Enter your ZIP code', '</h2>',
      '<p>', isRu ? 'Доступность товаров и варианты доставки могут различаться в зависимости от местоположения. Введите ваш ZIP-код, чтобы увидеть, что доступно в вашем регионе.' : 'Product availability and delivery options may vary by location. Enter your ZIP code to view what\'s available in your area.', '</p>',
      '<div class="gs-row">',
      '<input id="gs-zip-input" type="text" placeholder="12345"',
      ' maxlength="5" inputmode="numeric" autocomplete="postal-code"/>',
      '<button id="gs-zip-btn">', isRu ? 'Продолжить' : 'Continue', '</button>',
      '</div>',
      '<p id="gs-zip-error" class="gs-error" style="display:none"></p>',
      allowSkip ? '<button id="gs-zip-skip" class="gs-skip">' + (isRu ? 'Закрыть' : 'Close') + '</button>' : '',
      '</div>',
      '</div>',
    ].join('');
    document.body.appendChild(el);
    document.body.classList.add('gs-modal-open');

    document.getElementById('gs-zip-btn').addEventListener('click', handleSubmit);
    document.getElementById('gs-zip-input').addEventListener('keydown', function (e) {
      if (e.key === 'Enter') handleSubmit();
    });
    const skipBtn = document.getElementById('gs-zip-skip');
    if (skipBtn) {
      skipBtn.addEventListener('click', function () {
        el.remove();
        document.body.classList.remove('gs-modal-open');
      });
    }
    setTimeout(function () {
      var inp = document.getElementById('gs-zip-input');
      if (inp) inp.focus();
    }, 80);
  }

  const PIN_SVG = '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 22s7-7.58 7-12.5A7 7 0 0 0 5 9.5C5 14.42 12 22 12 22Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="12" cy="9.5" r="2.5" stroke="currentColor" stroke-width="1.6"/></svg>';

  async function handleSubmit() {
    const input = document.getElementById('gs-zip-input');
    const error = document.getElementById('gs-zip-error');
    const btn = document.getElementById('gs-zip-btn');
    const zip = input.value.trim();
    const isRu = document.documentElement.lang === 'ru';

    if (!/^\d{5}$/.test(zip)) {
      showError(error, isRu ? 'Пожалуйста, введите действительный 5-значный ZIP-код.' : 'Please enter a valid 5-digit ZIP code.');
      return;
    }

    btn.textContent = '...';
    btn.disabled = true;
    error.style.display = 'none';

    const state = await getStateFromZip(zip);

    if (!state) {
      showError(error, isRu ? 'ZIP-код не найден. Пожалуйста, попробуйте снова.' : 'ZIP code not found. Please try again.');
      btn.textContent = isRu ? 'Продолжить' : 'Continue';
      btn.disabled = false;
      return;
    }

    const zone = STATE_ZONES[state] || null;

    localStorage.setItem(ZIP_KEY, zip);
    localStorage.setItem(STATE_KEY, state);
    if (zone) localStorage.setItem(STORAGE_KEY, zone);

    document.getElementById(MODAL_ID).remove();
    document.body.classList.remove('gs-modal-open');

    if (zone) applyZoneRules(zone);
  }

  function showError(el, msg) {
    el.textContent = msg;
    el.style.display = 'block';
  }

  function init() {
    const savedZone = localStorage.getItem(STORAGE_KEY);

    if (savedZone) {
      applyZoneRules(savedZone);
    } else {
      showModal(false);
    }

    const trigger = document.getElementById('gs-zip-trigger');
    if (trigger) {
      trigger.addEventListener('click', resetZone);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();